import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const ErrorPage = () => {
  const [message, setMessage] = useState("Oops! Something went wrong");

  useEffect(() => {
    const errorMsg = sessionStorage.getItem("global_error");
    if (errorMsg) setMessage(errorMsg);
  }, []);

  return (
    <div style={styles.container}>
      <div style={styles.content}>
        <h1 style={styles.title}>Oops! Something Went Wrong</h1>
        <p style={styles.message}>{message}</p>
        <Link to="/" style={styles.link}>
          <button style={styles.button}>Go to Login</button>
        </Link>
      </div>
    </div>
  );
};



const styles = {
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    backgroundColor: "#f8f9fa",
  },
  content: {
    textAlign: "center",
    backgroundColor: "#ffffff",
    padding: "40px",
    borderRadius: "8px",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
    width: "300px",
  },
  title: {
    fontSize: "22px",
    fontWeight: "bold",
    color: "#333333",
    marginBottom: "10px",
  },
  message: {
    fontSize: "14px",
    color: "#666666",
    marginBottom: "20px",
  },
  link: {
    textDecoration: "none",
  },
  button: {
    backgroundColor: "#007bff",
    color: "#ffffff",
    border: "none",
    borderRadius: "5px",
    padding: "10px 20px",
    fontSize: "16px",
    cursor: "pointer",
    width: "100%",
    transition: "background-color 0.3s ease",
  },
};

export default ErrorPage;
